import { render } from "./PravView.vue?vue&type=template&id=57ec10ae&scoped=true"
import script from "./PravView.vue?vue&type=script&lang=js"
export * from "./PravView.vue?vue&type=script&lang=js"

import "./PravView.vue?vue&type=style&index=0&id=57ec10ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ec10ae"]])

export default __exports__